import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=288180dd&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=288180dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288180dd",
  null
  
)

export default component.exports